import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import { combineReducers, compose, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

// user actions
var SET_USER_AUTH_TOKEN = 'USER_SESSION:ACTION:SET_USER_AUTH_TOKEN';
var SET_USER_LOGGED_IN = 'USER_SESSION:ACTION:SET_USER_LOGGED_IN';
var SET_USER_LOGGED_OUT = 'USER_SESSION:ACTION:SET_USER_LOGGED_OUT';
var SET_USER_NAME = 'USER_SESSION:ACTION:SET_USER_NAME';

// @TODO ACT-1412 Remove once code using this has been updated
var SET_LOGGED_IN_DEPRECATED = 'LOGGED_IN';

// reg login actions
var HIDE_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:HIDE_REG_LOGIN_LIGHTBOX';
var HIDE_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:HIDE_GOOGLE_ONE_TAP';
var SET_REG_LOGIN_INPUT_VALUES = 'USER_SESSION:ACTION:SET_REG_LOGIN_INPUT_VALUES';
var SET_REG_LOGIN_NODE = 'USER_SESSION:ACTION:SET_REG_LOGIN_NODE';
var SET_REG_LOGIN_PATH = 'USER_SESSION:ACTION:SET_REG_LOGIN_PATH';
var SET_PASSWORD_REQUIRED = 'USER_SESSION:ACTION:SET_PASSWORD_REQUIRED';
var SET_RESET_PASSWORD_LINK_URL = 'USER_SESSION:ACTION:SET_RESET_PASSWORD_LINK_URL';
var SET_REG_LOGIN_REDIRECT_URL = 'USER_SESSION:ACTION:SET_REG_LOGIN_REDIRECT_URL';
var SET_REG_LOGIN_ZMA_HANDLERS = 'USER_SESSION:ACTION:SET_REG_LOGIN_ZMA_HANDLERS';
var SET_REG_LOGIN_UI_CONFIG = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG';
var SET_REG_LOGIN_UI_CONFIG_DEFAULTS = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG_DEFAULTS';
var SHOW_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:SHOW_REG_LOGIN_LIGHTBOX';
var SHOW_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:SHOW_GOOGLE_ONE_TAP';

// Onboarding questionnaire actions
var SHOW_ONBOARDING_QUESTIONNAIRE = 'USER_SESSION:ACTION:SHOW_ONBOARDING_QUESTIONNAIRE';
var HIDE_ONBOARDING_QUESTIONNAIRE = 'USER_SESSION:ACTION:HIDE_ONBOARDING_QUESTIONNAIRE';
var SET_ONBOARDING_CONFIG = 'USER_SESSION:ACTION:SET_ONBOARDING_CONFIG';

var DEFAULT_UI_CONFIG = {
  headerText: 'Welcome to Zillow',
  gaLabel: 'generic/generic',
  showTabs: true,
  renderNodeTarget: null,
  disableEmailForm: false,
  showProRegCheckbox: true
};
var initialState = {
  inputValues: {},
  path: '/',
  redirectUrl: '',
  showLightbox: false,
  uiConfig: DEFAULT_UI_CONFIG
};

/**
 * Reduces register state.
 * @kind function
 * @param  {Object} state
 *                    current state to be reduced
 * @param  {{type: string, config: {zipcode: number, email: string}}} action
 *                    action payload
 * @return {Object} reduced state
 */
var regLoginReducer = function regLoginReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }
  if (action === void 0) {
    action = {};
  }
  switch (action.type) {
    case HIDE_GOOGLE_ONE_TAP:
      return Object.assign({}, state, {
        showGoogleOneTap: false
      });
    case HIDE_REG_LOGIN_LIGHTBOX:
      return Object.assign({}, state, {
        showLightbox: false
      });
    case SET_REG_LOGIN_INPUT_VALUES:
      return Object.assign({}, state, {
        inputValues: Object.assign({}, state.inputValues, action.inputValues)
      });
    case SET_REG_LOGIN_NODE:
      return Object.assign({}, state, {
        node: action.node
      });
    case SET_REG_LOGIN_PATH:
      return Object.assign({}, state, {
        path: action.path
      });
    case SET_REG_LOGIN_REDIRECT_URL:
      return Object.assign({}, state, {
        redirectUrl: action.redirectUrl
      });
    case SET_REG_LOGIN_UI_CONFIG:
      return Object.assign({}, state, {
        uiConfig: Object.assign({}, state.uiConfig, action.uiConfig || DEFAULT_UI_CONFIG)
      });
    case SET_REG_LOGIN_UI_CONFIG_DEFAULTS:
      return Object.assign({}, state, {
        uiConfig: Object.assign({}, DEFAULT_UI_CONFIG, action.uiConfig || {})
      });
    case SET_REG_LOGIN_ZMA_HANDLERS:
      return Object.assign({}, state, {
        zmaHandlerFns: action.zmaHandlerFns
      });
    case SET_PASSWORD_REQUIRED:
      return Object.assign({}, state, {
        requiresPassword: action.requiresPassword
      });
    case SET_RESET_PASSWORD_LINK_URL:
      return Object.assign({}, state, {
        resetPasswordLinkUrl: action.resetPasswordLinkUrl
      });
    case SHOW_GOOGLE_ONE_TAP:
      return Object.assign({}, state, {
        showGoogleOneTap: true
      });
    case SHOW_REG_LOGIN_LIGHTBOX:
      return Object.assign({}, state, {
        showLightbox: true
      });
    default:
      return state;
  }
};

var initialState$1 = {
  loggedIn: false,
  name: ''
};

/**
 * Reduces register state.
 * @kind function
 * @param  {Object} state
 *                    current state to be reduced
 * @param  {String} action
 *                    action payload
 * @return {Object} reduced state
 */
var userReducer = function userReducer(state, action) {
  if (state === void 0) {
    state = initialState$1;
  }
  switch (action.type) {
    case SET_USER_AUTH_TOKEN:
      return Object.assign({}, state, {
        authToken: action.authToken
      });
    case SET_LOGGED_IN_DEPRECATED:
    case SET_USER_LOGGED_IN:
      return Object.assign({}, state, {
        loggedIn: true
      });
    case SET_USER_LOGGED_OUT:
      return Object.assign({}, state, {
        loggedIn: false
      });
    case SET_USER_NAME:
      return Object.assign({}, state, {
        name: action.name
      });
    default:
      return state;
  }
};

var initialState$2 = {
  // Controlled by SET_ONBOARDING_CONFIG
  zipCode: '',
  email: '',
  eligible: false,
  trial: '',
  variant: '',
  // Controlled by SHOW_ONBOARDING_QUESTIONNAIRE, HIDE_ONBOARDING_QUESTIONNAIRE
  showQuestionnaire: false
};

/**
 * Reduces register state.
 * @kind function
 * @param  {Object} state current state to be reduced
 * @param  {{zipCode: number, email: string, eligible: boolean, trial: string, variant: string, showQuestionnaire: boolean}} action
 * @return {Object} reduced state
 *
 * Controls the onboarding modal configuration and
 * when the onboarding modal is displayed
 */
var onboardingReducer = function onboardingReducer(state, action) {
  if (state === void 0) {
    state = initialState$2;
  }
  switch (action.type) {
    case SET_ONBOARDING_CONFIG:
      return Object.assign({}, state, action.config);
    case SHOW_ONBOARDING_QUESTIONNAIRE:
      return Object.assign({}, state, {
        showQuestionnaire: true
      });
    case HIDE_ONBOARDING_QUESTIONNAIRE:
      return Object.assign({}, state, {
        showQuestionnaire: false
      });
    default:
      return state;
  }
};

/**
 * Condense distinct global reducers to single reducer
 * @param  {Object} asyncReducers
 *                    map of async reducers to load
 * @return {Function} single reducer
 */
var makeRootReducer = function makeRootReducer(asyncReducers) {
  return combineReducers(Object.assign({
    // Add sync reducers here
    regLogin: regLoginReducer,
    user: userReducer,
    onboarding: onboardingReducer
  }, asyncReducers));
};

var USER_SESSION_INITIAL_STATE = '__USER_SESSION_INITIAL_STATE__';

/**
 * If no initial state is passed look for global
 * @returns {Object}
 */
function getInitialState() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window[USER_SESSION_INITIAL_STATE] || {};
}

/**
 * Whether or not global store already exists in window.
 * @return {Boolean}
 */
function hasUserSessionStore() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__Z_USER_SESSION_STORE__ !== undefined;
}

/**
 * Whether or not global store already exists in window.
 * @return {Object} global store
 */
function getUserSessionStore() {
  return createUserSessionStore();
}

/**
 * Creates global redux store to be used across react components.
 * @param  {Object}  config
 *   @param  {Array}    config.middleware - list of middleware to include in store. Redux thunk included
 *   @param  {Array}    config.enhancers - list of middleware to include in store
 *   @param  {Function} config.reducer - reducer function for global store
 *   @param  {Object}   config.initialState - starting state for store
 *   @param  {Boolean}  config.overrideExisting - whether or not to replace existing store
 * @return {Object} global store
 */
function createUserSessionStore(config) {
  var _middleware$enhancers = Object.assign({
      middleware: [],
      enhancers: [],
      reducer: makeRootReducer(),
      initialState: getInitialState(),
      overrideExisting: false
    }, config),
    middleware = _middleware$enhancers.middleware,
    enhancers = _middleware$enhancers.enhancers,
    reducer = _middleware$enhancers.reducer,
    initialState = _middleware$enhancers.initialState,
    overrideExisting = _middleware$enhancers.overrideExisting;
  if (!overrideExisting && hasUserSessionStore()) {
    return window.__Z_USER_SESSION_STORE__;
  }

  // modified compose to allow for use of Redux Tools extension
  // https://github.com/zalmoxisus/redux-devtools-extension
  var composeEnhancers = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  window.__Z_USER_SESSION_STORE__ = createStore(reducer, initialState, composeEnhancers.apply(void 0, [applyMiddleware.apply(void 0, [thunk].concat(_toConsumableArray(middleware)))].concat(_toConsumableArray(enhancers))));
  return window.__Z_USER_SESSION_STORE__;
}

export { DEFAULT_UI_CONFIG, USER_SESSION_INITIAL_STATE, createUserSessionStore, getUserSessionStore, hasUserSessionStore };
